import React, {
    Component,useState,useEffect
} from 'react';
import Menu from "../Menu";
import Header from '../Header';
import Footer from '../Footer';
import { Select } from 'antd';
import { Table, Tag, Space } from 'antd';
import { Modal } from 'antd';
import { connect, useDispatch, useSelector } from 'react-redux';
import {doGetVendorContractList,isEdit,addVendor} from './actions/vendorService'
import Cookie from 'js-cookie';
import VendorContractMapping from './VendorContractMapping';
import VendorContractMappingEdit from './VendorContractMappingEdit';
import Spinner from '../../UIComponents/Spinner/Spinner';
import MessageBox from '../../UIComponents/MessageBox/MessageBox';
import { Config } from '../../config/config';
import { useNavigate } from 'react-router-dom';
import LZString from 'lz-string';
const { Option } = Select;

const VendorContract = () =>{
    const jsonData = Cookie.get('currentUser');
              let decompressedData = LZString.decompressFromBase64(jsonData);
          decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
    const user = JSON.parse(decompressedData)
    const userID = user['userId'];
    const config = JSON.parse(Config);
    const apiInterface = config['api1']
    const status = useSelector(state =>state?.vendorList )
    const vendorContractList = useSelector(state => state?.vendorList.VendorContractDetails)
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [editData, setEditData] = useState([]);
    const title= "Vendor Contract"
    const DocModalvisible = false
    const MapModalVisible = false
    const message =''
    const modalOpen =false
    // const loading =false
    const [tableData, setTableData] = useState()
    const [searchedItem, setSearchedItem] = useState({
        main_category: [],
        sub_Category: [],
        Type_of_service: [],
        storeId:null,
    })
    const [subCategory, setSubCategory] = useState([]);
    const [MainCategory, setMainCategory] = useState([]);
    const TableColumns = [
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render:  (text, record) => (
                <Space size="middle">
                    <div className="table-icons">
                        <i className="fa fa-pencil blue" onClick={()=>vendorContractList?.AllowCreateOrEdit==1 ?_doEditVendor(record):null} aria-hidden="true" style={{cursor:vendorContractList?.AllowCreateOrEdit!=1 && 'not-allowed'}}></i>
                        {/* <i class="fa fa-cogs orange" onClick={this._doOpenVendorModal} aria-hidden="true"></i> */}
                        {/* <i className="fa fa-cogs orange" onClick={_doOpenVendorContract} aria-hidden="true"></i> */}
                    </div>
                </Space>
            ),
        },
        {
            title: "Main category name",
            width:120,
            dataIndex: "main_category_name",
            key: "MainCategoryName"
        },
        {
            title : 'Vendor Name',
            dataIndex:'vendor_company_name',
            key:"VendorCompanyName"
        },
        {
            title: "Sub category name",
            dataIndex: "sub_category_name",
            key: "SubCategoryName"
        },
        {
            title: "Asset name",
            dataIndex: "asset_name",
            key: "AssetName"
        },
        {
            title: "Contract start date",
            width:120,
            dataIndex: "contract_start_date",
            key: "ContractStartDate"
        },
        {
            title: "Contract end date",
            width:120,
            dataIndex: "contract_end_date",
            key: "ContractEndDate"
        },
        {
            title: "Download Document",
            dataIndex: "contract_file_name",
            key: "contract_file_name",
            render:  (text, record) => (
                <Space size="middle">
                    <div className="table-icons" style={{cursor:'pointer'}}>
                        <i className="fa fa-file-text" onClick={()=>handleDownload(record)} aria-hidden="true"></i>
                    </div>
                </Space>
            ),
        },
    ]
    const handleDownload = (ele) =>{
        // window.location.href = `${apiInterface}/downloadimages?Image_id=${ele.contract_file_name}`
        window.location.href = `${apiInterface}/downloadfiles?Image_id=${ele.contract_file_name}&token_id=${Cookie.get('token')}`
    }
    const _doSelectVender = (value) => {
        // setCategory(value);
        setSubCategory(vendorContractList?.SubCategory?.filter(ele => {
            if (value.includes(ele.maintenance_maincategory_id) && ele.store_id == searchedItem.storeId) {
                return ele;
            }
        }))

    }
    const getMainCategoryDropdown = (value)=>{
        searchedItem.main_category = []
        searchedItem.sub_Category = []  
        setSubCategory([])
            setSearchedItem({...searchedItem, main_category:[],sub_Category:[],})
        if(typeof(value) != "undefined"){
            console.log('inside if condition')
            setMainCategory(vendorContractList?.MainCategory)
        }
        else if(typeof(value)== "undefined"){
            setMainCategory([])
        }

    }
    const _doNavToVendors = () => {
        navigate("/Vendor");
    };
    const _doEditVendor=(data)=>{
        setEditData(data)
     dispatch(isEdit(true))
    }
    const _doNavToVendorContract = () => {
        dispatch(addVendor(true))
        navigate("/VendorContractMapping");
        setSearchedItem({
            main_category: [],
            sub_Category: [],
            Type_of_service: [],
            storeId:null,
        })
        setTableData(vendorContractList?.VendorsContractMappingList)
    };
    const _doOpenVendorContract = ()=>{

    }

    useEffect(() => {
        dispatch(doGetVendorContractList(userID))
    }, [])
    useEffect(()=>{
        if(searchedItem.main_category.length!=0 || searchedItem.sub_Category.length !=0 || searchedItem.Type_of_service.length!=0 || searchedItem.storeId !=null || searchedItem.storeId !="undefined"){
            handleSearch()
        }else{
            setTableData(vendorContractList?.VendorsContractMappingList)
        }
    },[vendorContractList])
    const onSearch = (val) => {
        console.log('search:', val);
    }
    const handleClose = () => {}

    const handleSearch = () =>{
        if(searchedItem.main_category.length == 0 && searchedItem.sub_Category.length ==0 && searchedItem.Type_of_service.length == 0 && searchedItem.storeId==null || searchedItem.storeId == 'undefined'){
            setTableData(vendorContractList?.VendorsContractMappingList)
        }
        else {
            if(searchedItem.main_category.length !=0 && searchedItem.sub_Category.length !=0 && searchedItem.Type_of_service.length !=0){
                let main =[]
                let fetchmain = vendorContractList?.VendorsContractMappingList.filter(ele=>JSON.stringify(Array.from(ele.main_catagory_id?.split(','),Number).sort())==JSON.stringify(searchedItem.main_category.sort())&& ele.store_id == searchedItem.storeId).map(data=>main.push(data))
                let sub =[]
                let fetchsub=main.filter(ele=>JSON.stringify(Array.from(ele.sub_catagory_id?.split(','),Number).sort())==JSON.stringify(searchedItem.sub_Category.sort())).map(data=>sub.push(data))
                let service = []
                let servicedata = sub.filter(ele=>JSON.stringify(Array.from(ele.type_of_service_ids.split(','),Number).sort())==JSON.stringify(searchedItem.Type_of_service.sort())).map(data=> service.push(data))
                setTableData(service)
            }
            else if(searchedItem.main_category.length !=0 && searchedItem.Type_of_service.length !=0){
                let main =[]
                let fetchmain = vendorContractList?.VendorsContractMappingList.filter(ele=>JSON.stringify(Array.from(ele.main_catagory_id?.split(','),Number).sort())==JSON.stringify(searchedItem.main_category.sort())&& ele.store_id == searchedItem.storeId).map(data=>main.push(data))
                let service = [];
                let servicedata = main.filter(ele=>JSON.stringify(Array.from(ele.type_of_service_ids.split(','),Number).sort())==JSON.stringify(searchedItem.Type_of_service.sort())).map(data=> service.push(data))
                setTableData(service)
            }
            else if(searchedItem.storeId && searchedItem.Type_of_service.length!=0){
                let storeData = vendorContractList?.VendorsContractMappingList.filter(ele=>ele.store_id==searchedItem.storeId)
                let service =[];
                let servicedata = storeData.filter(ele=>JSON.stringify(Array.from(ele.type_of_service_ids.split(','),Number).sort())==JSON.stringify(searchedItem.Type_of_service.sort())).map(data=> service.push(data))
                setTableData(service)
            }
            else if(searchedItem.main_category.length !=0 && searchedItem.sub_Category.length !=0){
                let main =[]
                let fetchmain = vendorContractList?.VendorsContractMappingList.filter(ele=>JSON.stringify(Array.from(ele.main_catagory_id?.split(','),Number).sort())==JSON.stringify(searchedItem.main_category.sort())&& ele.store_id == searchedItem.storeId).map(data=>main.push(data))
                let sub =[]
                let fetchsub=main.filter(ele=>JSON.stringify(Array.from(ele.sub_catagory_id?.split(','),Number).sort())==JSON.stringify(searchedItem.sub_Category.sort())).map(data=>sub.push(data))
                setTableData(sub)
            }
            else if(searchedItem.main_category.length !=0 && searchedItem.storeId){
                let storeData = vendorContractList?.VendorsContractMappingList.filter(ele=>ele.store_id==searchedItem.storeId)
                let main =[]
                let fetch = storeData.filter(ele=>JSON.stringify(Array.from(ele.main_catagory_id?.split(','),Number).sort())==JSON.stringify(searchedItem.main_category.sort()) && ele.store_id == searchedItem.storeId).map(data=>main.push(data))
                setTableData(main)
            }
            else if(searchedItem.Type_of_service.length !=0){
                let service = []
                let servicedata = vendorContractList?.VendorsContractMappingList.filter(ele=>JSON.stringify(Array.from(ele.type_of_service_ids.split(','),Number).sort())==JSON.stringify(searchedItem.Type_of_service.sort())).map(data=> service.push(data))
                setTableData(service)
            }
            else if(searchedItem.storeId){
                let storeData = vendorContractList?.VendorsContractMappingList.filter(ele=>ele.store_id==searchedItem.storeId)
                setTableData(storeData)
            }
        }
    }
    return ( 
        <>
           {status?.isVendorList?   <>
           {modalOpen?(
               <MessageBox 
                message = {message}
                signout = {false}
                onClose = {handleClose}
               />
           ):null}
          <Header title={title} />
            <Menu />

            <div className='content-wrapper'>
                {status?.loading?(<Spinner/>):(<>
                <div className="m-btn-block">
                    <div className="m-btn-block__container">
                        <div className="m-btn-block__icon">
                            <i className="fa fa-plus-circle" aria-hidden="true"></i>
                        </div>
                        <div className="m-btn-block__btns">
                            <button type='submit' onClick={vendorContractList?.AllowCreateOrEdit==1 ?_doNavToVendorContract:null} className='btn btn-secondary deca-btn-yellow' style={{cursor:vendorContractList?.AllowCreateOrEdit!=1 && 'not-allowed'}}>Contract Mapping</button>
                        </div>
                    </div>
                </div>
                <section className='content'>
                    <div className="m-panel mt-10">
                        <div className="m-panel__body p10">
                            <div className="row">
                                <div className="col-md-2">
                                    <div className='form-group'>
                                        <label htmlFor='exampleInput'>Stores</label>
                                        <Select className="form-control"
                                                showSearch
                                                allowClear={true}
                                                placeholder="-- Please Select --"
                                                optionFilterProp="children"
                                                onChange={(value) => { getMainCategoryDropdown(value); setSearchedItem({ ...searchedItem, storeId: value }) }}
                                                value={searchedItem.storeId}
                                                filterOption={(input, option) =>
                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                            >{
                                                    vendorContractList?.StoresDropdown?.map(item=>(
                                                        <Option key={item.store_id} value={item.store_id}>{item.store_name}</Option>
                                                    ))
                                                }
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className='form-group select_h150'>
                                        <label htmlFor='exampleInput'>Main category name</label>
                                        <Select className="form-control"
                                                showSearch
                                                allowClear={true}
                                                mode='multiple'
                                                placeholder="-- Please Select --"
                                                optionFilterProp="children"
                                                onChange={(value) => { _doSelectVender(value); setSearchedItem({ ...searchedItem, main_category: value }) }}
                                                value={searchedItem.main_category}
                                                filterOption={(input, option) =>
                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                            >{
                                                    MainCategory.map(item=>(
                                                        <Option key={item.id} value={item.id}>{item.name}</Option>
                                                    ))
                                                }
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className='form-group select_h150'>
                                        <label htmlFor='exampleInput'>Sub category name</label>
                                        <div className="">
                                            <Select className="form-control"
                                                showSearch
                                                allowClear={true}
                                                mode='multiple'
                                                placeholder="-- Please Select --"
                                                optionFilterProp="children"
                                                onChange={(value) => { setSearchedItem({ ...searchedItem, sub_Category: value }) }}
                                                value={searchedItem.sub_Category}
                                                filterOption={(input, option) =>
                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                            >{
                                                    subCategory.map(item=>(
                                                        <Option key={item.id} value={item.id}>{item.name}</Option>
                                                    ))
                                                }
                                            </Select>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className='form-group select_h150'>
                                        <label htmlFor='exampleInput'>Select type of services</label>
                                        <Select className="form-control"
                                            showSearch
                                            allowClear={true}
                                            mode='multiple'
                                            placeholder="-- Please Select --"
                                            optionFilterProp="children"
                                            onChange={(value) => { setSearchedItem({ ...searchedItem, Type_of_service: value }) }}
                                            value = {searchedItem.Type_of_service}
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        >
                                            {
                                                vendorContractList?.VendorsServices.map((ele,index)=>(
                                                    <Option key={index} value ={ele.id}>{ele.name}</Option>
                                                ))
                                            }
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-md-3 btn-no-lbl">
                                    <button type='submit' className='btn btn-secondary btn-icon deca-btn-yellow' onClick = {handleSearch}>
                                        <i className="fa fa-search"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="m-panel">
                        <div className="m-panel__body p10">
                            <div className="m-table__main">
                                <div className="m-table__responsive medium-width has-action-column single">
                                    <Table columns={TableColumns} dataSource={tableData} />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="row">
                        <div className="col-md-12 text-right">
                            <div className="m-page__button top-space">
                                <button type='button' onClick={this._doNavToVendors} className='btn muted-button  deca-btn-orange'>Back</button>
                            </div>
                        </div>
                    </div> */}
                
                    
                </section></>)}
                
            </div>
            </>:null}
            {
             status?.isVendorCreate?<VendorContractMapping />:null   
            }
            {
             status?.isVendorEdit?<VendorContractMappingEdit Editdata={editData} />:null   
            }
            <Footer />
        </>
    )
}
export default VendorContract